import { render, staticRenderFns } from "./ContractRenewalDisplay.vue?vue&type=template&id=73544fa6&"
import script from "./ContractRenewalDisplay.vue?vue&type=script&lang=ts&"
export * from "./ContractRenewalDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports